import { type IRatingProps, Rating } from '~/components/rating'

const InfoRating = (props: Omit<IRatingProps, 'onPress'>) => {
  return <Rating {...props} onPress={() => {}} />
}

export { InfoRating }
